import React from "react";
import moment from "moment";
import Text from "@amzn/meridian/text";
import { useAppSelector } from "../../app/store/hooks";

import { ITimeProps } from "./definitions";
import { useOnClickHandler } from "./hooks";
import styles from "./style.module.scss";
import { RELATIVE_TIME_FORMAT } from "../../constants/defaultsConstants";

const Time: React.FC<ITimeProps> = (props: ITimeProps) => {
    const time = props.isUnix ? moment.unix(props.timestamp) : moment(props.timestamp);
    const formattedTime = time.format(props.format ?? RELATIVE_TIME_FORMAT);
    const relativeTime = time.fromNow();

    const { isRelativeTimeFormat } = useAppSelector(state => state.time);
    const [label, setLabel] = React.useState<string>("");
    const [title, setTitle] = React.useState<string>("");
    const onClickHandler = useOnClickHandler();

    React.useEffect(() => {
        if (isRelativeTimeFormat) {
            setLabel(relativeTime);
            setTitle(formattedTime);
        } else {
            setLabel(formattedTime);
            setTitle(relativeTime);
        }
    }, [isRelativeTimeFormat, formattedTime, relativeTime]);

    return (
        <time onClick={onClickHandler} title={title}>
            <Text className={styles.clickableText} data-testid="clickable-text">
                <span>{label}</span>
            </Text>
        </time>
    );
};

export default Time;

export const formatDateTime = (date: string | number) => {
    return date ? <Time format="MM/DD/YYYY" timestamp={moment(date).valueOf()} /> : "-";
};
